export { default } from './assignInWith.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/extendWith.js
// module id = 608
// module chunks = 41